module.exports = __webpack_public_path__ + "media/images/webpage/coupons/ogp-7f1353cc595a7f408ed2c6a044b4bd47.webp";